import { render, staticRenderFns } from "./KirimBalik.vue?vue&type=template&id=59bcbf56&"
import script from "./KirimBalik.vue?vue&type=script&lang=js&"
export * from "./KirimBalik.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports